import {defineMessages} from 'react-intl';

export default defineMessages({
	descriptionCtaFindInStore: {
		id: 'productDetail.cta.findInStore',
		defaultMessage: 'Find in Store',
	},
	descriptionCtaBookAppointment: {
		id: 'productDetail.cta.bookAnAppointment',
		defaultMessage: 'Book an appointment',
	},
	descriptionCtaContactUs: {
		id: 'productDetail.cta.contactUs',
		defaultMessage: 'Contact Us',
	},
});
